import Title from '@organisms/Title'
import styled from '@emotion/styled'

export const StyledTitle = styled(Title)`
  white-space: pre-wrap;
`
